import * as React from 'react';

const Block16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m1.5 0c0-3.584 2.916-6.5 6.5-6.5 1.522 0 2.921.53 4.03 1.41l-9.121 9.12A6.47 6.47 0 0 1 1.5 8M8 14.5a6.46 6.46 0 0 1-4.03-1.409l9.12-9.12A6.46 6.46 0 0 1 14.5 8c0 3.584-2.916 6.5-6.5 6.5",
    clipRule: "evenodd"
  }
));
Block16.Size = 16;
Block16.Title = "Block";

export { Block16 as default };
